// react-routers components
// import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// React
import { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import { Edit, Save } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
// import ChemicalTable from "examples/Tables/ChemicalTable";

// firebase functions
import { doc, updateDoc } from "firebase/firestore";
import { TableContainer } from "@mui/material";
import { db } from "../../../firebaseDb";

function ChemicalsList({ title, sprayInfo, shadow }) {
  const [chemicalList, setChemicals] = useState(sprayInfo.chemicals);
  const [loading, setLoading] = useState(false);
  const [selectedrow, setSelectedRow] = useState("");

  // Update: setBatch accepts chemical index and ingredient index
  const setBatch = (value, chemIndex, ingIndex) => {
    setChemicals((prevArray) => {
      const newArray = [...prevArray];
      // Ensure ingredients array exists
      newArray[chemIndex].ingredients = newArray[chemIndex].ingredients || [];
      newArray[chemIndex].ingredients[ingIndex] = {
        ...newArray[chemIndex].ingredients[ingIndex],
        batchNo: value,
      };
      return newArray;
    });
  };

  const saveChemicals = (index, key) => {
    setLoading(true);
    setSelectedRow(index);
    const chemRef = doc(db, "Weedsprays", key);
    updateDoc(chemRef, { chemicals: chemicalList }).then(async () => {
      setLoading(false);
    });
  };

  const editChemicals = (index) => {
    setChemicals((prevArray) => {
      const newArray = [...prevArray];
      newArray[index].disabled = false;
      return newArray;
    });
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      <MDBox pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
      </MDBox>
      <TableContainer>
        <Table aria-label="simple table">
          <TableRow component="th">
            <TableCell sx={{ fontWeight: "bold" }} align="left">
              Chemical Name
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Spray Rate
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              First Ingredient (per Tank)
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Second Ingredient (per Tank)
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">
              Third Ingredient (per Tank)
            </TableCell>
            {/* Removed single Batch Number header - batch fields are per-ingredient */}
          </TableRow>
          <TableBody>
            {chemicalList.map((row, chemIndex) => (
              <TableRow
                hover
                key={row.key || `${chemIndex}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">{row.chemicalName}</TableCell>
                <TableCell align="center">{`${
                  Math.round(
                    row.ingredients.reduce((sum, ingredient) => {
                      const ratio = parseFloat(ingredient.ratio);
                      return sum + (ratio * sprayInfo.tankCapacity) / 100;
                    }, 0) * 100
                  ) / 100
                }L per Tank`}</TableCell>

                {/* For each ingredient column show name, volume and batch input */}
                {Array.from({ length: 3 }).map((_, ingColIndex) => {
                  const ing = row.ingredients?.[ingColIndex];
                  return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TableCell key={`${row.key || chemIndex}-ing-${ingColIndex}`}>
                      {ing ? (
                        <>
                          <TableRow>
                            <TableCell align="center">{ing.name}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              {`${
                                (ing.ratio *
                                  (sprayInfo?.sprayer?.[0]?.tankCapacity ||
                                    sprayInfo.tankCapacity ||
                                    0)) /
                                100
                              }L`}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">
                              <TextField
                                InputProps={{
                                  style: {
                                    backgroundColor: (() => {
                                      if (row.disabled) return "lightgrey";
                                      if (ing.batchNo) return "lightgreen";
                                      return "white";
                                    })(),
                                  },
                                }}
                                value={ing.batchNo || ""}
                                disabled={row.disabled}
                                onChange={(event) =>
                                  setBatch(event.target.value, chemIndex, ingColIndex)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      ) : (
                        <TableCell align="center">-</TableCell>
                      )}
                    </TableCell>
                  );
                })}

                {/* Save/Edit buttons for the chemical row */}
                {loading && chemIndex === selectedrow && (
                  <TableCell align="center">
                    <CircularProgress />
                  </TableCell>
                )}
                {!loading && (
                  <TableCell align="center">
                    {!row.disabled && (
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          saveChemicals(chemIndex, sprayInfo.key);
                        }}
                      >
                        <Save />
                      </Button>
                    )}
                    {row.disabled && (
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          editChemicals(chemIndex);
                        }}
                      >
                        <Edit />
                      </Button>
                    )}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

// Setting default props for the ProfilesList
ChemicalsList.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfilesList
ChemicalsList.propTypes = {
  title: PropTypes.string.isRequired,
  shadow: PropTypes.bool,
  sprayInfo: PropTypes.objectOf.isRequired,
};

export default ChemicalsList;
